import styled from '@emotion/styled';
import { Chip, Typography } from '@material-ui/core';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  title: string | null;
};

const CreativeBriefProjectNameChip: FC<Props> = ({ title }) => {
  return (
    <Chip
      label={
        <Typography variant="body2" color="inherit">
          <ProjectName>
            <FormattedMessage id="project_editing_page.creative_brief.project_name" values={{ projectName: title }} />
          </ProjectName>
        </Typography>
      }
      color="secondary"
    />
  );
};

const ProjectName = styled.span`
  font-weight: bold;
`;

export default CreativeBriefProjectNameChip;
